import { useState } from 'react'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Link as UILink } from '@tribeplatform/react-ui-kit/Link'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { T } from '../i18n/components/T.js'

import { ModelItem } from './components/ModelItem.js'
import { ModelsAccordionButton } from './components/ModelsAccordionButton.js'
import { useCMS } from './hooks/useCMS.js'
import { ModelSettings } from './settings/ModelSettings.js'

export const CMSList = () => {
  const {
    allActiveCMSTypes,
    allActivePostTypes,
    allActiveReplyTypes,
    allArchivedCMSTypes,
  } = useCMS()
  const [newModelMode, setNewModelMode] = useState(false)
  const { data: network } = useNetwork()
  const [canCreatePostType] = hasScopesPermission(network, ['createPostType'])

  if (allActiveCMSTypes.length === 0) {
    return null
  }

  if (newModelMode) {
    return <ModelSettings isNew goBack={() => setNewModelMode(false)} />
  }

  return (
    <NavVertical>
      <NavVertical.Group>
        <Accordion variant="chevron-down" defaultOpen>
          <Accordion.Button>
            <ModelsAccordionButton
              onAddModel={() => setNewModelMode(true)}
              canAddModel={canCreatePostType}
            />
          </Accordion.Button>
          <Accordion.Panel noPadding>
            <NavVertical.Group>
              {allActivePostTypes.map(postType => (
                <ModelItem key={postType.id} postType={postType} />
              ))}
              {allActiveReplyTypes.map(postType => (
                <ModelItem key={postType.id} postType={postType} />
              ))}
              {canCreatePostType && (
                <NavVertical.Item
                  as={UILink}
                  leadingIcon={
                    <div className="me-3 -ms-1">
                      <SvgIcon name="plus" size="lg" />
                    </div>
                  }
                  className="ps-9"
                  onClick={() => setNewModelMode(true)}
                >
                  <div className="flex-1 truncate">
                    <T defaultMessage="Add model" id="Admin.CMS.AddModel" />
                  </div>
                </NavVertical.Item>
              )}
            </NavVertical.Group>
          </Accordion.Panel>
        </Accordion>
        {allArchivedCMSTypes.length !== 0 && (
          <Accordion variant="chevron-down">
            <Accordion.Button>
              <span className="truncate font-semibold">
                <T
                  defaultMessage="Archived models"
                  id="Admin.CMS.Model.ArchivedModels"
                />
              </span>
            </Accordion.Button>
            <Accordion.Panel noPadding>
              <NavVertical.Group>
                {allArchivedCMSTypes.map(postType => (
                  <ModelItem key={postType.id} postType={postType} />
                ))}
              </NavVertical.Group>
            </Accordion.Panel>
          </Accordion>
        )}
      </NavVertical.Group>
    </NavVertical>
  )
}
